import styled from 'styled-components';

import { PrimaryButton } from 'components/Button';

const BreedButton = styled(PrimaryButton)`
  padding: 1.5rem;
  margin: 1rem;
  width: 250px;
  height: 135px;
  text-align: center;
  text-transform: capitalize;
  word-wrap: break-word;
`;

export default BreedButton;
